import React from 'react';
import { Link } from 'react-router-dom';
import { Leaf, Mail, Phone, MapPin, ArrowUp, Linkedin, Instagram, Facebook, Twitter } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer style={{
      background: 'var(--dark-900)',
      borderTop: '1px solid var(--border)',
      position: 'relative',
    }}>
      {/* Back to top button */}
      <button
        onClick={scrollToTop}
        style={{
          position: 'absolute',
          top: '-24px',
          right: '48px',
          width: '48px',
          height: '48px',
          background: 'var(--gradient-primary)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          cursor: 'pointer',
          border: 'none',
          boxShadow: 'var(--shadow-lg)',
          transition: 'transform 0.3s ease',
        }}
        onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-4px)'}
        onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
      >
        <ArrowUp size={20} />
      </button>

      <div className="container" style={{ padding: '80px 0 40px' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '2fr 1fr 1fr 1fr',
          gap: '60px',
          marginBottom: '60px',
        }} className="footer-grid">
          {/* Brand Column */}
          <div>
            <Link to="/" style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              fontFamily: 'var(--font-serif)',
              fontSize: '1.5rem',
              fontWeight: 700,
              color: 'var(--text-primary)',
              marginBottom: '20px',
            }}>
              <div style={{
                width: '40px',
                height: '40px',
                background: 'var(--gradient-primary)',
                borderRadius: '10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
              }}>
                <Leaf size={20} />
              </div>
              <span>Carbon<span style={{ color: 'var(--primary-400)' }}>Tech</span></span>
            </Link>
            <p style={{
              color: 'var(--text-muted)',
              lineHeight: 1.7,
              fontSize: '0.95rem',
              marginBottom: '24px',
            }}>
              Transformando el futuro ambiental de Paraguay con soluciones innovadoras de carbono. Tecnología brasileña, compromiso paraguayo.
            </p>
            <div style={{ display: 'flex', gap: '12px' }}>
              {[Facebook, Linkedin, Instagram, Twitter].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  style={{
                    width: '40px',
                    height: '40px',
                    background: 'var(--dark-800)',
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'var(--text-muted)',
                    transition: 'all 0.3s ease',
                    border: '1px solid var(--border)',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'var(--primary-600)';
                    e.currentTarget.style.color = 'white';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'var(--dark-800)';
                    e.currentTarget.style.color = 'var(--text-muted)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>

          {/* Links Columns */}
          {[
            {
              title: 'Empresa',
              links: ['Sobre Nosotros', 'Servicios', 'Proyectos', 'Galería', 'Contacto'],
            },
            {
              title: 'Legal',
              links: ['Términos de Uso', 'Política de Privacidad', 'Certificaciones', 'Licencias'],
            },
            {
              title: 'Recursos',
              links: ['Blog', 'Preguntas Frecuentes', 'Documentación', 'Trabaja con Nosotros'],
            },
          ].map((column) => (
            <div key={column.title}>
              <h4 style={{
                fontSize: '1rem',
                fontWeight: 600,
                marginBottom: '24px',
                color: 'var(--text-primary)',
              }}>
                {column.title}
              </h4>
              <ul style={{ listStyle: 'none' }}>
                {column.links.map((link) => (
                  <li key={link} style={{ marginBottom: '12px' }}>
                    <a
                      href="#"
                      style={{
                        color: 'var(--text-muted)',
                        fontSize: '0.9rem',
                        transition: 'color 0.3s ease',
                      }}
                      onMouseEnter={(e) => e.target.style.color = 'var(--primary-400)'}
                      onMouseLeave={(e) => e.target.style.color = 'var(--text-muted)'}
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div style={{
          borderTop: '1px solid var(--border)',
          paddingTop: '30px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '20px',
        }}>
          <p style={{
            color: 'var(--text-muted)',
            fontSize: '0.85rem',
          }}>
            © 2024 CarbonTech S.A. Todos los derechos reservados. Naranjal, Alto Paraná, Paraguay.
          </p>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '24px',
            color: 'var(--text-muted)',
            fontSize: '0.85rem',
          }}>
            <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <Mail size={14} /> proyectos@carbontech.com.py
            </span>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 1024px) {
          .footer-grid {
            grid-template-columns: 1fr 1fr !important;
          }
        }
        @media (max-width: 640px) {
          .footer-grid {
            grid-template-columns: 1fr !important;
            gap: 40px !important;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
